import Keycloak from 'keycloak-js';

// Get environment variables with fallbacks
const getEnvVar = (name, fallback) => {
  // Check runtime environment variables (injected by Docker)
  if (window._env_ && window._env_[name]) {
    return window._env_[name];
  }
  // Check build-time environment variables
  if (process.env[name]) {
    return process.env[name];
  }
  // Return fallback
  return fallback;
};

// Create Keycloak instance as a singleton
let keycloakInstance = null;

const getKeycloakInstance = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: getEnvVar('REACT_APP_KEYCLOAK_URL', 'https://sign-me-in.techsys.co.za'),
      realm: getEnvVar('REACT_APP_KEYCLOAK_REALM', 'hills'),
      clientId: getEnvVar('REACT_APP_KEYCLOAK_CLIENT_ID', 'coupon-insights-ui'),
    });
  }
  return keycloakInstance;
};

// Keycloak initialization options - using proper authorization code flow + PKCE for public client
export const keycloakInitOptions = {
  onLoad: 'login-required', // Force login immediately
  checkLoginIframe: false,
  // Use standard authorization code flow with PKCE (secure modern approach for SPAs)
  flow: 'standard',
  pkceMethod: 'S256', // PKCE for security (perfect for public clients)
  scope: 'openid profile email coupon-insights',
  // Additional configuration
  enableLogging: true, // Enable logging to debug authentication issues
  // Force redirect to login if not authenticated
  redirectUri: window.location.origin,
  // Response mode
  responseMode: 'fragment', // Use fragment for SPA compatibility
};

export default getKeycloakInstance(); 